// extracted by mini-css-extract-plugin
export default {"img":"WorksheetCarousel__img___iXMzJ"};